import { KairosService } from '../../services/kairos.service';
var AltaKairosComponent = /** @class */ (function () {
    function AltaKairosComponent(kairosService) {
        this.kairosService = kairosService;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.kairos = {
            nombre: "",
            tipo: 1,
            archivo: null
        };
        this.tipoActualizacion = [
            { "descripcion": "Actualizacion Diaria", "valor": 1 },
            { "descripcion": "Actualizacion Semanal", "valor": 2 },
            { "descripcion": "Base de datos completa", "valor": 3 },
            { "descripcion": "Microsoft Access", "valor": 4 }
        ];
        this.errores = new Array();
    }
    AltaKairosComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
    };
    AltaKairosComponent.prototype.onChange = function (e) {
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        var ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        if (ext !== "zip") {
            alert("El formato del archivo no es válido");
        }
        else {
            this.kairos.archivo = file;
        }
    };
    AltaKairosComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.kairosService.guardar(this.kairos)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizacion Kairos";
            if (result.status == 201) {
                _this.kairos = {
                    nombre: "",
                    tipo: 1,
                    archivo: null
                };
                _this.fileInput.nativeElement.value = "";
                _this.alert.tipo = "success";
                _this.alert.mensaje = "La actualizacion se ha guardado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los datos no se han podido guardar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizacion Kairos";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los datos no se han podido guardar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    AltaKairosComponent.ctorParameters = function () { return [{ type: KairosService }]; };
    return AltaKairosComponent;
}());
export { AltaKairosComponent };
//# sourceMappingURL=alta-kairos.component.js.map


// WEBPACK FOOTER //
// alta-kairos.component.js